skrilla.directive('skrillaPagination',function() {
    return {
        templateUrl: 'directives/pagination/pagination.html',
        scope: {
            key: "="
        },
        controller: function($scope, paginationService){
            $scope.MAX_BUTTONS_PER_SIDE = 2;

            function handleNewPageData() {
                if($scope.currentPage === undefined){
                    $scope.currentPage = 0;
                }
                if($scope.page.limit > 0) {
                    $scope.page.totalPages = Math.ceil($scope.page.totalEntities / $scope.page.limit);
                }else{
                    $scope.page.totalPages = 0;
                }
                populateArr();
            }

            function populateArr(){
                $scope.arr = [];
                var smallestButton = Math.max(0, $scope.page.currentPage - $scope.MAX_BUTTONS_PER_SIDE);
                var biggestButton = Math.min($scope.page.totalPages -1, $scope.page.currentPage + $scope.MAX_BUTTONS_PER_SIDE);
                for (var i = smallestButton; i <= biggestButton; i++) {
                    $scope.arr.push(i)
                }
            }

            $scope.page = paginationService.getPage($scope.key);
            handleNewPageData();
            paginationService.pageUpdateListener(handleNewPageData, $scope.key);

            $scope.goToPage = function(num){
                $scope.page.currentPage = num == 'first' ? 0 : num == 'last' ? $scope.page.totalPages - 1 : num;
                $scope.page.offset = $scope.page.currentPage * $scope.page.limit;
                $scope.page.query();
                populateArr();
            }

        }
    };
});
